var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('span',[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"more",on:{"click":_vm.go}},[_vm._v("更多")])])}
var staticRenderFns = []

export { render, staticRenderFns }